import TagManager from "react-gtm-module";
const defaultCity = "blitar";
const tagManagerArgs = {
  gtmId: "GTM-K4LC4T6",
};

function init() {
  TagManager.initialize(tagManagerArgs);
}

function sendEvent(payload) {
  const event = {
    dataLayer: {
      ...payload,
      user_id: "not login yet",
    },
  };
  TagManager.dataLayer(event);
}

export default {
  init,
  sendEvent,
  defaultCity,
};
